<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-white page-border">
            <!--page body contant -->
            <!--header-->

            <div class="row row-replace add-m-b">
                <div class="col-md-2 col-6 col-p h5"><i class="fa fa-book"></i> COVID-19 Helpdesk</div>
                <div class="col-md-10 col-6 top-corner-items col-p">
                    <!-- <button class="btn btn-primary btn-sm m-r-5" (click)="openModal('#staff_accom_data')">Covid19 Staff Accomodation Query</button> -->
                    <!-- <button class="btn btn-primary btn-sm m-r-5" [routerLink]="['/dashboard/workplace-permission']"> Workplace Permission</button> -->
                    <!-- <button class="btn btn-warning btn-sm m-r-5" (click)="wpReport()"><i class="fa fa-download" aria-hidden="true"></i> Permission Report</button> -->
                    <!-- <button class="btn btn-primary btn-sm m-r-5" [routerLink]="['/dashboard/self-covid-register']"> Vaccination Declaration Form</button> -->
                    <button class="btn btn-primary btn-sm" [routerLink]="['/dashboard']"><i class="fa fa-arrow-left"></i> Back</button>
                </div>
            </div>

            <div class="row row-replace add-m-b anc">
                <button class="col-md-2 btn btn-primary" [routerLink]="['/dashboard/workplace-permission']">
                  Workplace Permission Form
				</button>
                <button class="col-md-2 btn btn-warning" (click)="ssoLogin('helpline_covid19')">
                       Vaccination Declaration Form
				</button>
                <button class="col-md-2 btn btn-primary" (click)="ssoLogin('helpline_covid19')">
                       Covid 19 Sieze The Day
				</button>
                <button class="col-md-2 btn btn-warning" (click)="ssoLogin('helpline_covid19')">
                      Covid 19 Staff Accomodation Query
				</button>
                <button class="col-md-2 btn btn-primary" (click)="ssoLogin('helpline_covid19')">
                      Vaccination Requisition Form
				</button>
                <button class="col-md-2 btn btn-warning" (click)="ssoLogin('helpline_covid19')">
                      Admin Vaccination Requisition Approval
                </button>
                <button class="col-md-2 btn btn-warning" (click)="ssoLogin('list_accomodation')">
                  Admin Vaccination Requisition Approval
            </button>

            </div>
            <!--end header-->


            <div class="row row-replace m-t-30 grid-container-1">
                <div class="grid-items-box" *ngFor="let data of dashBoard; let i = index" [ngClass]="{'bg-primary text-white': 0 === i % 2}" (click)="iconDetail(data)">{{data.label}}</div>
            </div>
            <!--end page body contant -->
        </div>
    </div>
</div>
<!-- /Page Wrapper -->

<!-- For model -->
<div id="staff_accom_data" class="modal  custom-modal fade" data-backdrop="static" role="dialog">
    <div class="modal-dialog   modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="zero_country_form_title">Create Your Request</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()"><span aria-hidden="true">&times;</span></button>
            </div>
            <form [formGroup]="accomondationForm" (ngSubmit)="submitAccomondationData()">
                <div class="modal-body">
                    <div class="form-group">
                        <div class="row">
                            <div class="col-4">
                                <label for="aaaa">On Behalf Of Employee</label>
                            </div>
                            <div class="col-8">
                                <input type="text" class="form-control" formControlName="onbelf_emp">
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="row">
                            <div class="col-4">
                                <label for="aaaa">Emp ID<span class="text-danger">*</span></label>
                            </div>
                            <div class="col-8">
                                <input type="text" class="form-control" placeholder="Emp ID" readonly formControlName="user_id">
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="row">
                            <div class="col-4">
                                <label for="aaaa">Emp Name<span class="text-danger">*</span></label>
                            </div>
                            <div class="col-8">
                                <input type="text" class="form-control" placeholder="Emp Name" readonly formControlName="emp_nm">
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="row">
                            <div class="col-4">
                                <label for="aaaa">Region<span class="text-danger">*</span></label>
                            </div>
                            <div class="col-8">
                                <input type="text" class="form-control" placeholder="Region" readonly formControlName="region">
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="row">
                            <div class="col-4">
                                <label for="aaaa">Cost Center<span class="text-danger">*</span></label>
                            </div>
                            <div class="col-8">
                                <select class="form-control" formControlName="cc_id">
		                         <option>Cost center</option>
		                     </select>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="row">
                            <div class="col-4">
                                <label for="aaaa">Staff Accommodation Address<span class="text-danger">*</span></label>
                            </div>
                            <div class="col-8">
                                <textarea class="form-control" formControlName="accom_address"></textarea>

                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="row">
                            <div class="col-4">
                                <label for="aaaa">No of Staff Staying<span class="text-danger">*</span></label>
                            </div>
                            <div class="col-8">
                                <input type="text" class="form-control" formControlName="staff_stay">
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="row">
                            <div class="col-4">
                                <label for="aaaa">Square Feet Area:</label>
                            </div>
                            <div class="col-8">
                                <textarea class="form-control" formControlName="sq_feet"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="row">
                            <div class="col-4">
                                <label for="aaaa">Remarks<span class="text-danger">*</span></label>
                            </div>
                            <div class="col-8">
                                <input type="text" class="form-control" formCotrolName="remarks">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary btn-sm ">Submit</button>
                </div>
            </form>
        </div>
    </div>
</div>
